import React from 'react';
import { Helmet } from 'react-helmet-async';

import { isProduction } from 'src/shared/helpers/environment';

const APP_ID = isProduction() ? '6476119562' : '6476736099';
export const HomeownerMobileAppBanner = () => (
  <Helmet>
    <meta content={`app-id=${APP_ID}`} name="apple-itunes-app" />
  </Helmet>
);
